import { Map } from 'immutable';

export default Map({
  loading: false,
  data: null,
  existing: null,
  filters: [],
  filtersLoading: false,
  filtersError: false,
});
